<template>
  <div class="home">
    <NavBar />
    <keep-alive :include="cachedPage">
      <router-view />
    </keep-alive>
    <AppFooter />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import AppFooter from '@/components/Footer.vue'

export default {
  name: 'Layout',
  components: {
    NavBar,
    AppFooter
  },
  data () {
    return {
      cachedPage: ['News', 'About']
    }
  }
}
</script>
